import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const NotificationContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  background: #ff6b6b;
  color: white;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  max-width: 400px;
  animation: slideIn 0.3s ease-out;
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const NotificationTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
`;

const NotificationMessage = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  line-height: 1.4;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
`;

const LoginButton = styled(Button)`
  background: white;
  color: #ff6b6b;
  
  &:hover {
    background: #f0f0f0;
  }
`;

const DismissButton = styled(Button)`
  background: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const SessionExpiredNotification = ({ onLogin, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Auto-dismiss after 10 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onDismiss) onDismiss();
    }, 10000);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  const handleLogin = () => {
    setIsVisible(false);
    if (onLogin) onLogin();
  };

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) onDismiss();
  };

  if (!isVisible) return null;

  return (
    <NotificationContainer>
      <NotificationTitle>Session Expired</NotificationTitle>
      <NotificationMessage>
        Your session has expired. Please log in again to continue using your account features.
      </NotificationMessage>
      <ButtonContainer>
        <LoginButton onClick={handleLogin}>
          Log In
        </LoginButton>
        <DismissButton onClick={handleDismiss}>
          Dismiss
        </DismissButton>
      </ButtonContainer>
    </NotificationContainer>
  );
};

export default SessionExpiredNotification;
